
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["iconify iconify--wpf",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","width":"32","height":"32","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M13 0c-2.1 0-3.357.32-4.156.719-.4.2-.684.41-.875.625a2 2 0 00-.313.531 1 1 0 00-.062.25l-.532 6.844c-.007.042.007.11 0 .156L7 9.813A1.003 1.003 0 007 10c0 3.3 2.7 6 6 6s6-2.7 6-6v-.156a1.003 1.003 0 000-.031l-.594-7.688a1 1 0 00-.062-.25s-.121-.316-.313-.531c-.191-.216-.475-.426-.875-.625C16.357.319 15.1 0 13 0zm0 16c-6.6 0-12 3.106-12 5.906V26h24v-4.094c0-2.66-4.882-5.59-11.031-5.875A14.294 14.294 0 0013 16zm0-14c1.9 0 2.849.3 3.25.5.134.067.15.093.188.125l.406 5.125C15.924 7.806 14.67 8 13 8s-2.923-.194-3.844-.25l.406-5.125c.037-.032.054-.058.188-.125.401-.2 1.35-.5 3.25-.5zm-.813 1v1.188H11v1.625h1.188V7h1.624V5.812H15V4.188h-1.188V3h-1.624zM10 18.25L12.563 24H3v-2.094c0-.745 2.55-2.927 7-3.656zm6 0c4.45.73 7 2.911 7 3.656V24h-9.563L16 18.25z"}})])
          )
        }
      }
    